import React from "react";
import { Trans, useTranslation } from "react-i18next";

import {
  Box,
  Heading,
  Spacing,
  Stack,
  Text,
} from "@noom/wax-component-library";

import { NoomHeader } from "@/components/noom-branding";

export const GinaAdaView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <NoomHeader />
      <Box margin="auto" maxWidth="800px" padding="var(--spacing-m)">
        <Stack marginBottom="var(--spacing-xxh)" spacing={Spacing[8]}>
          <Heading fontSize="24px" lineHeight="32px">
            {t("ginaAda.header")}
          </Heading>
          <Text>{t("ginaAda.description.0")}</Text>
          <Text>{t("ginaAda.description.1")}</Text>
          <Text>
            <Trans
              components={{ underline: <u /> }}
              i18nKey="ginaAda.description.2"
            />
          </Text>
          <Text>{t("ginaAda.description.3")}</Text>
        </Stack>
      </Box>
    </Box>
  );
};
